import { MolsonBox } from '@components/reusable'
import { molsonStyled } from '@theme/customMuiExports'
export const ContentBox = molsonStyled(MolsonBox)({
  '.MuiAccordion-root:last-of-type:after': {
    background: 'transparent'
  },
  '.MuiPaper-root .MuiAccordionSummary-root': {
    padding: '20px 0'
  },
  '.MuiPaper-root:first-of-type .MuiAccordionSummary-root': {
    paddingTop: 0
  },
  '.MuiPaper-root:last-of-type .MuiAccordionSummary-root': {
    paddingBottom: 0
  }
})
